var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('a',{staticClass:"gl-link__wrapper",attrs:{"href":_vm.url,"target":_vm.target}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }